export class ComparedValueEntity {
  current!: number
  previous!: number
  diff!: number
}

export class PlanCountEntity {
  plan!: string
  count!: number
}

export class UsersTotalsEntity {
  paid_subscribers!: number
  free_users!: number
  free_subscribers!: number
  incomplete_signups!: number
  churned!: number
  apple_subscribers!: number
  stripe_subscribers!: number
  total!: number
  // Optional: a backend deployed before the member-activity change does not send these.
  total_members?: number
  active_members?: number
  inactive_members?: number
  paid_plans!: PlanCountEntity[]
}

export class UserMetricPeriodEntity {
  date!: string
  unique!: number
  new_subscribers!: number
  new_free_subscribers!: number
  churned!: number
  // Optional: a backend deployed before MT251-316 does not send these.
  subscribers_yearly?: number
  subscribers_monthly?: number
}

export class UsersMetricsEntity {
  unique!: ComparedValueEntity
  new_subscribers!: ComparedValueEntity
  new_free_subscribers!: ComparedValueEntity
  churned!: ComparedValueEntity
  new_subscribers_by_plan!: PlanCountEntity[]
  periods!: UserMetricPeriodEntity[]
}

export class DashboardMediaItemEntity {
  id!: string
  name!: string
  value!: number
  diff!: number
  image_url!: string
}

export class DashboardMediaTotalsEntity {
  songs_played!: ComparedValueEntity
  videos_viewed!: ComparedValueEntity
  most_played_songs!: DashboardMediaItemEntity[]
  most_viewed_videos!: DashboardMediaItemEntity[]
}

export class DashboardEventsEntity {
  buy_now_clicks!: ComparedValueEntity
  presale_codes_redeemed!: ComparedValueEntity
  meet_and_greet_redeemed!: ComparedValueEntity
  rsvp_redeemed!: ComparedValueEntity
}

export class DashboardCommunityEntity {
  viewed_posts!: ComparedValueEntity
  post_created!: ComparedValueEntity
  comments!: ComparedValueEntity
  upvotes!: ComparedValueEntity
}

export class DashboardChatEntity {
  active_users!: ComparedValueEntity
  messages_sent!: ComparedValueEntity
  unique_messages!: ComparedValueEntity
}

export class DashboardEntity {
  overview!: DashboardOverviewEntity
  user_metrics!: UsersMetricsEntity
  media_totals!: DashboardMediaTotalsEntity
  events!: DashboardEventsEntity
  community!: DashboardCommunityEntity
  chat!: DashboardChatEntity
}

export class DashboardOverviewEntity {
  total_users!: number
  paid_users!: number
  free_users!: number
  free_subscribers!: number
  churned_users!: number
  incomplete_signups!: number
  total_members?: number
  active_members?: number
  inactive_members?: number
  paid_plans!: PlanCountEntity[]
}
